// extracted by mini-css-extract-plugin
export var controls = "styles-module--controls--7a714";
export var image = "styles-module--image--03ff6";
export var slider = "styles-module--slider--c1dd1";
export var title = "styles-module--title--700b9";
export var wrapper = "styles-module--wrapper--f3426";